import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardString } from "@msuite/utils/strings";
import type { Nullable } from "@msuite/utils/types";
import { client } from "@/hono";

export function useOrder(orderId: Nullable<string>) {
	/** Query */
	const query = useQuery({
		queryKey: ["order", guardString(orderId)],
		queryFn: async () => {
			const response = await client.stock.orders[":orderId"].$get({
				param: { orderId: guardString(orderId) },
			});
			// The list route and this one are gated on the same `read Stock`, so a refusal here is
			// the whole page rather than one card of it — `Order` draws its no-access state from
			// `isError` and leaves the toast to the routes a caller reaches on purpose.
			const data = await responseHandler(response, false);
			return data.order;
		},
		enabled: !!orderId,
	});

	/** Return */
	return { ...query, order: query.data };
}
